/**
 * RTWO Cryptography & Identity Engine — Provider Catalog
 */

import type { IIdentityBackend, IdentityBackendType } from '../adapters/identity-backend-interface';
import type { IKeyProvider, KeyProviderType } from '../adapters/key-provider-interface';
import {
  createIdentityBackendCatalog,
  createKeyProvider,
  createOperationalKeyProviders,
  createScaffoldKeyProviders,
} from './crypto-provider-factory';

export const CRYPTO_KEY_PROVIDER_IDS = {
  ED25519: 'ed25519-key-provider',
  SECP256K1: 'secp256k1-key-provider',
  HSM: 'hsm-key-provider',
  KMS: 'kms-key-provider',
  SECURE_ENCLAVE: 'secure-enclave-key-provider',
} as const;

export const CRYPTO_IDENTITY_BACKEND_IDS = {
  SYSTEM_REGISTRY: 'system-registry-identity-backend',
  PEER_NETWORK: 'peer-network-identity-backend',
} as const;

export function createKeyProviderCatalog(): Map<KeyProviderType, IKeyProvider> {
  const catalog = createOperationalKeyProviders();
  for (const [providerType, provider] of createScaffoldKeyProviders()) {
    catalog.set(providerType, provider);
  }
  return catalog;
}

export { createIdentityBackendCatalog };

export function getKeyProviderForType(
  providerType: KeyProviderType,
  catalog?: Map<KeyProviderType, IKeyProvider>
): IKeyProvider | null {
  const providers = catalog ?? createKeyProviderCatalog();
  return providers.get(providerType) ?? createKeyProvider(providerType);
}

export function getIdentityBackendForType(
  backendType: IdentityBackendType,
  catalog?: Map<IdentityBackendType, IIdentityBackend>
): IIdentityBackend | null {
  return (catalog ?? createIdentityBackendCatalog()).get(backendType) ?? null;
}
